export const useAnalytics = () => {
  const trackEvent = (
    eventName: string,
    eventParams?: { [key: string]: any }
  ) => {
    if (window.gtag) {
      window.gtag('event', eventName, eventParams);
    }
  };

  return {
    // Wallet Events
    trackWalletConnect: (walletType: string) => {
      trackEvent('wallet_connect', {
        wallet_type: walletType,
      });
    },
    trackWalletDisconnect: () => {
      trackEvent('wallet_disconnect');
    },

    // Network Events
    trackNetworkSwitch: (fromNetwork: string, toNetwork: string) => {
      trackEvent('network_switch', {
        from_network: fromNetwork,
        to_network: toNetwork,
      });
    },

    // Token Creation Events
    trackTokenCreation: (tokenType: string, chainId: number) => {
      trackEvent('token_create', {
        token_type: tokenType,
        chain_id: chainId,
      });
    },
    trackTokenDeployment: (tokenAddress: string, chainId: number) => {
      trackEvent('token_deploy', {
        token_address: tokenAddress,
        chain_id: chainId,
      });
    },

    // Form Events
    trackFormSubmit: (formName: string) => {
      trackEvent('form_submit', {
        form_name: formName,
      });
    },
    trackFormError: (formName: string, errorMessage: string) => {
      trackEvent('form_error', {
        form_name: formName,
        error_message: errorMessage,
      });
    },

    // Button Click Events
    trackButtonClick: (buttonName: string, buttonLocation: string) => {
      trackEvent('button_click', {
        button_name: buttonName,
        button_location: buttonLocation,
      });
    },

    // Feature Usage Events
    trackFeatureUse: (featureName: string, params?: { [key: string]: any }) => {
      trackEvent('feature_use', {
        feature_name: featureName,
        ...params,
      });
    },

    // Error Events
    trackError: (errorType: string, errorMessage: string) => {
      trackEvent('error', {
        error_type: errorType,
        error_message: errorMessage,
      });
    },
  };
};
